import { gql } from '@apollo/client';

export const DELETE_UNKNOWN_USER_TEMPLATE = gql`
    mutation DeleteUnknownUserTemplate($id: Guid!) {
        system {
            unknownUserTemplates {
                delete(id: $id)
            }
        }
    }
`;
